export const WebComponentsConstants = {
  dropdownItems: [
    {
      label: "Japanese Yen",
      value: "JPY",
    },
    {
      label: "United States Dollar",
      value: "USD",
    },
  ],
  radioButtonItems: [
    { label: "Women's Outer", value: "A1" },
    { label: "Men's Outer", value: "A2" },
    { label: "Kid's", value: "A3" },
  ],
  multipleSelectItems: [
    { label: "Label 1", value: "Value A", selected: true },
    { label: "Label 2", value: "Value B", selected: true },
    { label: "Label 3", value: "Value C", selected: true },
    { label: "Label 4", value: "Value D", selected: true },
    { label: "Label 5", value: "Value E", selected: false },
    { label: "Label 6", value: "Value F", selected: false },
    { label: "Label 7", value: "Value G", selected: false },
    { label: "Label 8", value: "Value H", selected: false },
    { label: "Label 9", value: "Value I", selected: false },
    { label: "Label 10", value: "Value J", selected: false },
  ],
  iconList: [
    "frIcon:add",
    "frIcon:ascending",
    "frIcon:attention",
    "frIcon:calendar",
    "frIcon:check-square-some",
    "frIcon:check-square",
    "frIcon:chevron-down",
    "frIcon:chevron-left",
    "frIcon:chevron-right",
    "frIcon:chevron-up",
    "frIcon:close",
    "frIcon:col-folded",
    "frIcon:col-unfolded",
    "frIcon:database-linked",
    "frIcon:database",
    "frIcon:delete",
    "frIcon:descending",
    "frIcon:detail",
    "frIcon:dropdown",
    "frIcon:edit",
    "frIcon:filter-applied",
    "frIcon:filter",
    "frIcon:if-file-encrypted-linked",
    "frIcon:if-file-encrypted",
    "frIcon:if-file-linked",
    "frIcon:if-file",
    "frIcon:information",
    "frIcon:menu-close",
    "frIcon:minus-circle",
    "frIcon:more-horizontal",
    "frIcon:plus-circle",
    "frIcon:question",
    "frIcon:right-arrow",
    "frIcon:row-folded",
    "frIcon:row-unfolded",
    "frIcon:search",
    "frIcon:sort",
    "frIcon:square",
    "frIcon:success",
    "frIcon:synonym",
    "frIcon:text-file",
    "frIcon:settings",
  ],
  request: {
    params: {
      yearPlanningSeason: "2017-FW",
      name: "Smith Jolin",
      gender: "female",
      interests: ["swim", "dance"],
      business: ["11", "55", "A2"],
    },
  },
  searchConditions: [
    {
      label: "Yr/Planning Season",
      itemKey: "yearPlanningSeason",
    },
    {
      label: "Name",
      itemKey: "name",
    },
    {
      label: "Gender",
      itemKey: "gender",
    },
    {
      label: "Interests",
      itemKey: "interests",
    },
    {
      label: "Business",
      itemKey: "business",
      candidates: [
        { label: "UQJP", value: "11" },
        { label: "Women's Outer", value: "22" },
        { label: "Men's Outer", value: "33" },
        { label: "2017-FW", value: "44" },
        { label: "2017/05/13 - 2017/06/06", value: "55" },
        { label: "Uploaded", value: "66" },
        { label: "Taro Tamada", value: "77" },
        { label: "Value 2", value: "A2" },
        { label: "Value 3", value: "A3" },
        { label: "Value 3.1", value: "A4" },
        { label: "Value 3.2", value: "A5" },
      ],
    },
    {
      label: "BranchFactory",
      itemKey: "branchFactory",
    },
  ],
  tabItems: [
    {
      label: "Category1",
      value: "1",
    },
    {
      label: "Category2",
      value: "2",
    },
    {
      label: "Category3",
      value: "3",
    },
    {
      label: "Category4",
      value: "4",
    },
  ],
  listBuilderItems: [
    {
      code: "1000001",
      name: "T-shirt+OS",
      checked: false,
      added: false,
    },
    {
      code: "1000002",
      name: "W’s Sweet pants",
      checked: false,
      added: true,
    },
    {
      code: "1000003",
      name: "Slim fit pants",
      checked: false,
      added: false,
    },
    { code: "1000004", name: "Ezy jeans", checked: false, added: true },
  ],
  columnSettingListBuilderItems: [
    {
      code: "1000001",
      name: "T-shirt+OS",
      checked: false,
      added: false,
    },
    {
      code: "1000002",
      name: "W’s Sweet pants",
      checked: false,
      added: true,
    },
    {
      code: "1000003",
      name: "Slim fit pants",
      checked: false,
      added: false,
    },
    {
      code: "1000004",
      name: "Ezy jeans",
      checked: false,
      added: true,
    },
  ],
  tags: [
    { label: "ITEM1", value: "1" },
    { label: "ITEM2", value: "2" },
    { label: "ITEM3", value: "3" },
    { label: "ITEM4", value: "4" },
    { label: "ITEM5", value: "5" },
  ],
};
